"use strict";
class LanguageSubscriber {
}
exports.LanguageSubscriber = LanguageSubscriber;
